import ActionTypes from '../constants/ActionTypes';

export function isArticleLoaded(state, key) {
  if (
    state.articles.status[key] &&
    state.articles.status[key] === ActionTypes.FETCH_ARTICLE_SUCCESS
  ) {
    const article = getArticleByKey(state, key);
    return !article.partial;
  }
  return false;
}

export function areArticlesLoaded(state) {
  return !!(
    state.articles.status[0] &&
    [ActionTypes.FETCH_ARTICLES_SUCCESS, ActionTypes.FETCH_ARTICLES_ERROR].includes(
      state.articles.status[0]
    )
  );
}
export function getArticleByKey(state, key) {
  return state.articles.list[key] || {};
}

export function getArticleStatusByKey(state, key) {
  return state.articles.status && state.articles.status[key];
}

export function getArticles(state) {
  return state.articles.list;
}

export function getPage(state) {
  return state.articles.page;
}

export function getPerPage(state) {
  return state.articles.perPage;
}

export function getTotalArticles(state) {
  return state.articles.totalArticles;
}

export function getParams(state) {
  return state.articles.params;
}
